export const skillsData = [
  "HTML",
  "CSS",
  "Javascript",
  "Typescript",
  "React",
  "Next",
  "Next Auth",
  "Axios",
  "Node",
  "Prisma",
  "Zod",
  "Tailwind",
  "Bootstrap",
  "Git",
  "Github",
  "MaterialUI",
  "ShadcnUI",
  "FlowbiteUI",
  "Canva",
];
